interface UserWithPermissions {
	permissions?: string[];
}

// Admin: has "development.add_development"
export function isAdmin(user?: UserWithPermissions | null): boolean {
	return !!user?.permissions?.includes("development.add_development");
}

// Backend dev: has "endpoint_request.change_endpointrequest"
export function isBackendDev(user?: UserWithPermissions | null): boolean {
	return !!user?.permissions?.includes("change_endpointrequest");
}

// Frontend dev: has BOTH "endpoint_request.add_endpointrequest" AND "endpoint_request.add_component"
export function isFrontendDev(user?: UserWithPermissions | null): boolean {
	const perms = user?.permissions || [];
	return perms.includes("endpoint_request.add_endpointrequest") && perms.includes("endpoint_request.add_component");
}

//but the problem arises when l remove the endpoint_request part from the permission string above it will now start to show all the 3 dashboards